import Vue from 'vue'

import VueSlider from 'vue-slider-component'
import DurationSet from '@therapy/components/DurationSet'
import PictureTab from '@therapy/components/PictureTab'
import Tabs from '@/components/tabs/index'
// const components = [VueSlider, DurationSet, PictureTab, Tabs]

// components.map(component => {
//   Vue.component(component.name, component)
// })

Vue.component('v-slider', VueSlider)
Vue.component('duration-set', DurationSet)
Vue.component('picture-tab', PictureTab)
Vue.component('tabs', Tabs)
